// extracted by mini-css-extract-plugin
export default {"primerSection":"Header_primerSection__pqO2F","titulo":"Header_titulo__3GP5j","iconoModo":"Header_iconoModo__VS2tu"};